var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"mt-10",attrs:{"button-path":_vm.cta.url,"label":_vm.cta.text,"variant":_vm.cta.type,"new-tab":_vm.cta.newTab,"size":"large"}})}
var staticRenderFns = []

export { render, staticRenderFns }